import type { LucideIcon } from 'lucide-react';

import { DropdownMenuItem } from '@nesso/ui/primitives/dropdown-menu';

interface DropdownActionItemProps {
    icon?: LucideIcon;
    label: string;
    onClick: () => void;
}

export function UserDropdownActionItem({ icon: Icon, label, onClick }: DropdownActionItemProps) {
    return (
        <DropdownMenuItem onClick={onClick} className="m-1 mb-0 py-2">
            {Icon && <Icon className="h-4 w-4" />}
            <span>{label}</span>
        </DropdownMenuItem>
    );
}
